import Vue from 'vue'

const onInputChange = (value) => {
  switch (typeof value) {
    case 'string':
      return value?.trim() || null
    case 'number':
      return Number(value) || null
    case 'boolean':
      return !!value
    default:
      return value || null
  }
}

Vue.prototype.$onInputChange = onInputChange

export default onInputChange
